import { Capacitor } from "@capacitor/core";
import { runNativePrompt } from "@/lib/nativePrompts";

// Apple App Tracking Transparency (Guideline 2.1 / 5.1.2). The ATT framework ships in
// the iOS binary (AdMob SDK), so the prompt MUST be shown before any tracking could
// happen — independently of whether AdMob iOS is enabled in the admin config.
// Triggered on a fresh install right after « Accepter et continuer » (pages/Welcome.jsx),
// then re-checked (idempotent) by admob.initAdMob before UMP/initialize and by AppTrackingGate.
// iOS shows the system dialog once per install; later calls only read the status
// (le plugin capacitor-admob-nextgen renvoie directement le statut courant).
let pending = null;
let lastStatus = null; // dernier statut ATT connu dans cette session (iOS uniquement)

export const isIosNative = () => Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios";

// Lot 714 — statut ATT iOS de la session : "authorized" | "denied" | "restricted" | "notDetermined" | "error" ; null si
// jamais demandé ; "unavailable" hors iOS natif.
export const lastAppTrackingStatus = () => (isIosNative() ? lastStatus : "unavailable");
// Apple (5.1.2) : seul « authorized » autorise un suivi publicitaire ; tout autre statut vaut refus.
export const appTrackingAuthorized = (status = lastStatus) => !isIosNative() || status === "authorized";

export function requestAppTracking() {
  if (!isIosNative()) return Promise.resolve("unavailable");
  if (pending) return pending;
  pending = runNativePrompt("att", async () => {
    const { AdMobNextGen } = await import("capacitor-admob-nextgen");
    const res = await AdMobNextGen.requestTrackingAuthorization();
    lastStatus = res?.status || "unknown";
    return lastStatus;
  }).catch((e) => {
    console.warn("ATT prompt failed:", e?.message || e);
    pending = null;
    lastStatus = "error";
    return "error";
  });
  return pending;
}
